/*eslint-disable*/
import { CheckBox } from 'components/CheckBox/CheckBox'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { ISelectValue } from 'constants/globalTypes'
import React, { useState } from 'react'
import { Animation, Button, ButtonsContainer, Flex, TabFooter } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import { standardFieldValidation } from 'utils/validationUtils'
import { WelfareConatainer } from 'pages/Employees/Employees.styled'
import { logisticsTransportationTypes } from 'pages/Employees/employeesData'
import { IRolesTab } from 'types/roles.interface'
import { CancelBtn } from 'components/Button/CancelBtn'
import { tierOptions } from 'pages/Accomodation/Sections/CheckIn'

export const RoleWelfareTab = ({
    state,
    setState,
    handleSubmit
}: IRolesTab) => {
    const [invalidFields, setInvalidFields] = useState<string[]>([])

    const handleCheckbox = (name: string, fieldsToReset?: string[]) => {
        setInvalidFields(prev => {
            let copy = [...prev]
            if (state.logisticsInfo?.[name]) {

                if (name == 'hasFoodAllowance') {
                    copy = copy.filter(f => f !== 'foodAllowanceInCompanyAmount' && f !== 'foodAllowanceOutCompanyAmount')
                }
                if (name == 'hasAccommodationAllowance') {
                    copy = copy.filter(f => f !== 'accomodationAllowanceInCompanyAmount' && f !== 'accomodationAllowanceOutCompanyAmount')
                }
                if (name == 'hasTransportationAllowance') {
                    copy = copy.filter(f => f !== 'transportationAllowanceInCompanyAmount' && f !== 'transportationAllowanceOutCompanyAmount')
                }
                if (name == 'hasResponsibilityAllowance') {
                    copy = copy.filter(f => f !== 'responsibilityAllowanceInCompanyAmount' && f !== 'responsibilityAllowanceOutCompanyAmount')
                }
                if (name == 'hasExtraDutyAllowance') {
                    copy = copy.filter(f => f !== 'extraDutyAllowanceInCompanyAmount' && f !== 'extraDutyAllowanceOutCompanyAmount')
                }
            } else {
                if (name == 'hasFoodProvided') {
                    copy = [...copy, 'foodDietaryPreferenceType']
                }
                if (name == 'hasFoodAllowance') {
                    copy = [...copy, 'foodAllowanceInCompanyAmount', 'foodAllowanceOutCompanyAmount']
                }

                if (name == 'hasAccommodationAllowance') {
                    copy = [...copy, 'accomodationAllowanceInCompanyAmount', 'accomodationAllowanceOutCompanyAmount']
                }
                if (name == 'hasTransportationAllowance') {
                    copy = [...copy, 'transportationAllowanceInCompanyAmount', 'transportationAllowanceOutCompanyAmount']
                }
                if (name == 'hasResponsibilityAllowance') {
                    copy = [...copy, 'responsibilityAllowanceInCompanyAmount', 'responsibilityAllowanceOutCompanyAmount']
                }
                if (name == 'hasExtraDutyAllowance') {
                    copy = [...copy, 'extraDutyAllowanceInCompanyAmount', 'extraDutyAllowanceOutCompanyAmount']
                }

            }
            return copy
        })

        setState(prev => {
            if (fieldsToReset) {
                let copy = structuredClone(prev)
                fieldsToReset.forEach(f => {
                    copy.logisticsInfo[f] = null
                })
            }
            return { ...prev, logisticsInfo: { ...prev.logisticsInfo, [name]: !prev.logisticsInfo?.[name] } }

        })
    }

    const handleSelect = (v: ISelectValue, n: string) => {

        // TODO: Treba refactor ovoga, ovo je temp fix bio
        setInvalidFields(prev => {
            let copy = [...prev]

            if (n == 'accommodation') {
                if (v.value) {
                    copy = copy.filter(f => f !== 'accommodation')
                } else {
                    copy = [...copy, 'accommodation']
                }
            }

            if (n == 'foodDietaryPreferenceType') {
                if (v.value) {
                    copy = copy.filter(f => f !== 'foodDietaryPreferenceType')
                } else {
                    copy = [...copy, 'foodDietaryPreferenceType']
                }
            }

            return copy
        })
        setState(prev => ({ ...prev, logisticsInfo: { ...prev.logisticsInfo, [n]: v.value } }))
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { valueAsNumber, name } = e.target
        standardFieldValidation(e, setInvalidFields, true)
        setState(prev => ({ ...prev, logisticsInfo: { ...prev.logisticsInfo, [name]: valueAsNumber } }))
    }

    return <Animation>
        <WelfareConatainer >
            <Flex padding='1rem' width='100%' container column gap='1rem'  >
                <TitleText weight='bold' style={{ fontSize: 18 }} >Food</TitleText>
                <CheckBox state={state?.logisticsInfo?.hasFoodProvided} onClick={() => handleCheckbox('hasFoodProvided',)} square title='Include Food' />
                <CheckBox state={state?.logisticsInfo?.hasFoodAllowance} onClick={() => handleCheckbox('hasFoodAllowance', ['foodAllowanceInCompanyAmount', 'foodAllowanceOutCompanyAmount'])} square title='Food Allowance' />
                {state?.logisticsInfo?.hasFoodAllowance && <>
                    <Input allowZero name='foodAllowanceInCompanyAmount' onChange={handleChange} type='number' value={state?.logisticsInfo?.foodAllowanceInCompanyAmount} labelText='Food Allowance (Internal)' placeholder='1500' nomarg invalid={invalidFields.includes('foodAllowanceInCompanyAmount')} />
                    <Input allowZero name='foodAllowanceOutCompanyAmount' onChange={handleChange} type='number' value={state?.logisticsInfo?.foodAllowanceOutCompanyAmount} labelText='Food Allowance (External)' placeholder='500' nomarg invalid={invalidFields.includes('foodAllowanceOutCompanyAmount')} />
                </>}
            </Flex>
            <Flex padding='1rem' width='100%' container column gap='1rem'  >
                <TitleText weight='bold' style={{ fontSize: 18 }} >Accommodation</TitleText>
                <CheckBox state={state?.logisticsInfo?.hasAccommodationProvided} onClick={() => handleCheckbox('hasAccommodationProvided')} square title='Include Accommodation' />
                {/* {state?.logisticsInfo?.hasAccommodationProvided && <HonestSelectAsyncInput
                    name='accommodation'
                    labelText='Accommodation provided'
                    onChange={handleSelect}
                    placeholder='Select Accomodation'
                    link='accommodation/management/accommodation'
                    parserFunction={parse}
                    defaultValue={state?.logisticsInfo?.accommodation?.label}
                    invalid={invalidFields.includes('accommodation')}
                    nomarg
                />} */}
                <CheckBox state={state?.logisticsInfo?.hasAccommodationAllowance} onClick={() => handleCheckbox('hasAccommodationAllowance', ['accomodationAllowanceInCompanyAmount', 'accomodationAllowanceOutCompanyAmount'])} square title='Accommodation Allowance' />
                {state?.logisticsInfo?.hasAccommodationAllowance && <>
                    <Input allowZero name='accomodationAllowanceInCompanyAmount' onChange={handleChange} type='number' value={state?.logisticsInfo?.accomodationAllowanceInCompanyAmount} labelText='Accommodation Allowance (Internal)' placeholder='1500' nomarg invalid={invalidFields.includes('accomodationAllowanceInCompanyAmount')} />
                    <Input allowZero name='accomodationAllowanceOutCompanyAmount' onChange={handleChange} type='number' value={state?.logisticsInfo?.accomodationAllowanceOutCompanyAmount} labelText='Accommodation Allowance (External)' placeholder='500' nomarg invalid={invalidFields.includes('accomodationAllowanceOutCompanyAmount')} />
                </>}
                <HonestSelectInput options={tierOptions} labelText='Accommodation Tier' name='accomodationTierPolicy' defaultValue={state?.logisticsInfo?.accomodationTierPolicy} onChange={handleSelect} nomarg />

            </Flex>
            <Flex padding='1rem' width='100%' container column gap='1rem'  >
                <TitleText weight='bold' style={{ fontSize: 18 }} >Transportation</TitleText>
                <HonestSelectInput options={logisticsTransportationTypes} labelText='Transport Type' name='transportationType' defaultValue={state?.logisticsInfo?.transportationType} onChange={handleSelect} nomarg invalid={invalidFields.includes('transportationType')} required />


                <CheckBox state={state?.logisticsInfo?.hasTransportationAllowance} onClick={() => handleCheckbox('hasTransportationAllowance', ['transportationAllowanceInCompanyAmount', 'transportationAllowanceOutCompanyAmount'])} square title='Transport Allowance' />
                {state?.logisticsInfo?.hasTransportationAllowance && <>
                    <Input allowZero name='transportationAllowanceInCompanyAmount' onChange={handleChange} type='number' value={state?.logisticsInfo?.transportationAllowanceInCompanyAmount} labelText='Transport Allowance (Internal)' placeholder='1500' nomarg invalid={invalidFields.includes('transportationAllowanceInCompanyAmount')} />
                    <Input allowZero name='transportationAllowanceOutCompanyAmount' onChange={handleChange} type='number' value={state?.logisticsInfo?.transportationAllowanceOutCompanyAmount} labelText='Transport Allowance (External)' placeholder='500' nomarg invalid={invalidFields.includes('transportationAllowanceOutCompanyAmount')} />
                </>}
            </Flex>
            <Flex padding='1rem' width='100%' container column gap='1rem'  >
                <TitleText weight='bold' style={{ fontSize: 18 }} >Responsibility and Extra Duty Allowance</TitleText>
                <CheckBox state={state?.logisticsInfo?.hasResponsibilityAllowance} onClick={() => handleCheckbox('hasResponsibilityAllowance', ['responsibilityAllowanceInCompanyAmount', 'responsibilityAllowanceOutCompanyAmount'])} square title='Include Responsibility Allowance' />
                {state?.logisticsInfo?.hasResponsibilityAllowance && <>
                    <Input allowZero name='responsibilityAllowanceInCompanyAmount' onChange={handleChange} type='number' value={state?.logisticsInfo?.responsibilityAllowanceInCompanyAmount} labelText='Responsibility Allowance (Internal)' placeholder='1500' nomarg invalid={invalidFields.includes('responsibilityAllowanceInCompanyAmount')} />
                    <Input allowZero name='responsibilityAllowanceOutCompanyAmount' onChange={handleChange} type='number' value={state?.logisticsInfo?.responsibilityAllowanceOutCompanyAmount} labelText='Responsibility Allowance (External)' placeholder='500' nomarg invalid={invalidFields.includes('responsibilityAllowanceOutCompanyAmount')} />
                </>}
                <CheckBox state={state?.logisticsInfo?.hasExtraDutyAllowance} onClick={() => handleCheckbox('hasExtraDutyAllowance', ['extraDutyAllowanceInCompanyAmount', 'extraDutyAllowanceOutCompanyAmount'])} square title='Include Extra Duty Allowance' />
                {state?.logisticsInfo?.hasExtraDutyAllowance && <>
                    <Input allowZero name='extraDutyAllowanceInCompanyAmount' onChange={handleChange} type='number' value={state?.logisticsInfo?.extraDutyAllowanceInCompanyAmount} labelText='Extra Duty Allowance (Internal)' placeholder='1500' nomarg invalid={invalidFields.includes('extraDutyAllowanceInCompanyAmount')} />
                    <Input allowZero name='extraDutyAllowanceOutCompanyAmount' onChange={handleChange} type='number' value={state?.logisticsInfo?.extraDutyAllowanceOutCompanyAmount} labelText='Extra Duty Allowance (External)' placeholder='500' nomarg invalid={invalidFields.includes('extraDutyAllowanceOutCompanyAmount')} />
                </>}
            </Flex>

        </WelfareConatainer>
        <TabFooter  >
            <ButtonsContainer>
                <CancelBtn />
                <Button orange onClick={handleSubmit}>
                    Save
                </Button>
            </ButtonsContainer>
        </TabFooter>
    </Animation>
}